import React from 'react';

import { Link } from "react-router-dom";

import Icon from '@material-ui/core/Icon';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    cardWrapper: {
        margin: '10px auto',
        '& p': {
            marginBottom: theme.spacing(2)
        },
    },
    table: {
        width: '100%',
        '& td, & th': {
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            lineHeight: '1.43',
            letterSpacing: '0.01071em',
        },
        '& tbody tr': {
            borderBottomColor: theme.palette.divider,
            borderBottomWidth: 1,
            borderBottomStyle: 'solid',
            '&:last-child': {
                borderBottom: 'none'
            },
        }
    },
    bordered: {
        borderBottomColor: theme.palette.divider,
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
    },
    card: {
        backgroundColor: theme.palette.grey[100],
        '& .MuiCardContent-root': {
            padding: theme.spacing(1),
        }
    }
}));


const BalanceDetailWrapper = (props) => {
    const {
        balance,
    } = props;

    const classes = useStyles();

    const parseNum = num => parseFloat(num || 0);

    const formatNumber = (number) => {
        return (number !== '' && number !== undefined) ? parseFloat(number).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
        }) : '';
    }

    let subTotal = 0;

    const isAdmin = window.isAdmin;

    return (
        <Grid
            container
            spacing={4}
        >
            <Grid item xs={12}>
                <Typography variant="h6">Couple Balance: {balance.bride_full_name} and {balance.groom_full_name}</Typography>
            </Grid>
            <Grid item xs={12} className={classes.cardWrapper}>
                <Card square className={classes.card}>
                    <CardContent>
                        <table className={classes.table}>
                            <thead>
                                <tr className={classes.bordered}>
                                    {isAdmin && <th />}
                                    <th>Item #</th>
                                    <th>Type</th>
                                    <th>Date</th>
                                    <th className="text-center">Invoice</th>
                                    <th className="text-center">Invoice Due Date</th>
                                    <th className="text-center">Payment</th>
                                    <th className="text-center">Balance</th>
                                </tr>
                            </thead>
                            <tbody>
                                {balance.transactions.length > 0 && balance.transactions.map(row => {
                                    subTotal = row.type == 'Payment' ? subTotal - parseFloat(row.payment) : subTotal + parseFloat(row.invoice);
                                    const link = row.type == 'Payment' ? `/admin/payments/${row.id}` : `/admin/invoices/${row.id}`;
                                    subTotal = parseNum(subTotal.toFixed(4));
                                    return (
                                        <tr key={`${row.type[0]}-${row.id}`}>
                                            {isAdmin && <th><Link to={link}><Icon>visibility</Icon></Link></th>}
                                            <td>#{row.id.toString().padStart(5, '0')}</td>
                                            <td>{row.type}</td>
                                            <td>{row.date}</td>
                                            <td className="text-center">{formatNumber(row.invoice)}</td>
                                            <td className="text-center">{row.date_due}</td>
                                            <td className="text-center">{formatNumber(row.payment)}</td>
                                            <td className="text-center">{formatNumber(subTotal)}</td>
                                        </tr>
                                    )
                                })}
                                {!balance.transactions.length > 0 && (
                                    <tr>
                                        <td colSpan={isAdmin ? 7 : 6} className="text-center">
                                            <Typography variant="body2" component="span" color="textSecondary">No invoices or payments yet</Typography>
                                        </td>
                                    </tr>
                                )}
                                <tr>
                                    {isAdmin && <td></td>}
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="text-center">{formatNumber(subTotal)}</td>
                                </tr>
                            </tbody>
                        </table>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    )
}

export default BalanceDetailWrapper;
